import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Loader from '../../components/Loader';
import SuccessGlassIcon from '../../assets/svg_components/SuccessGlassIcon';
import PublicPaymentStyle from './PublicPayment.module.scss';
import useCustomQuery from '../../network/useCustomQuery';
import { GET_MERCHANT_RENT_PAYMENT_DETAILS } from '../../graphql/queries';
import ResponseModal from '../../modal_views/global/ResponseModal';
import PaymentinProgressIcon from '../../assets/svg_components/PaymentinProgressIcon';
import PaymentProcessModal from '../../modal_views/PaymentProcessModal';

const PublicPayment = () => {
  const { transactionReference } = useParams();
  const navigate = useNavigate();

  const [paymentData, setPaymentData] = useState<any>(null);
  const [modalDetails, setShowModalDetails] = useState<any>(null);

  const [getMerchantRentPaymentByTransactionRef] = useCustomQuery({
    query: GET_MERCHANT_RENT_PAYMENT_DETAILS,
    onError: () => {},
    onData: () => {}
  });

  const Icon: any = {
    success: <SuccessGlassIcon />,
    caution: <PaymentinProgressIcon />,
    failed: <PaymentinProgressIcon />
  };

  const getRentPaymentByTransactionRefApi = async () => {
    try {
      const result = await getMerchantRentPaymentByTransactionRef({
        variables: {
          transactionReference
        }
      });

      const trxStatus = result?.data?.getMerchantRentPaymentByTransactionRef?.status;
      if (trxStatus === 200) {
        setPaymentData(result?.data?.getMerchantRentPaymentByTransactionRef?.data);
        return;
      }
      let modalPayload: any = {};
      if (trxStatus === 404) {
        modalPayload = {
          title: 'Transaction not found',
          message: 'The transaction reference provided does not exist or is invalid.',
          iconType: 'failed'
        };
      } else if (trxStatus === 400) {
        modalPayload = {
          title: 'Transaction already processed',
          message: 'The transaction reference provided has already been processed.',
          iconType: 'caution'
        };
      } else {
        modalPayload = {
          title: 'Opertaion failed',
          message:
            result?.data?.getMerchantRentPaymentByTransactionRef?.message ||
            'An error occurred while processing the transaction.',
          iconType: 'failed'
        };
      }
      setShowModalDetails(modalPayload);
    } catch (error) {
      setShowModalDetails({
        title: 'An error occurred',
        message: 'An error occurred while processing the transaction.',
        iconType: 'failed'
      });
    }
  };

  useEffect(() => {
    if (transactionReference) {
      getRentPaymentByTransactionRefApi();
    }
  }, [transactionReference]);

  if (modalDetails) {
    return (
      <ResponseModal
        isShow
        onClickAway={() => {}}
        onBack={() => {}}
        onClose={() => {}}
        title={modalDetails.title}
        icon={Icon[modalDetails.iconType]}
        subTitle={modalDetails.message}
        btnTitle="OKAY"
        isShowCloseIcon={false}
        onPress={() => {
          setShowModalDetails(null);
          setPaymentData(null);
          if (modalDetails?.redirectUrl) {
            window.location.href = modalDetails.redirectUrl;
          } else {
            navigate(modalDetails?.goToLink || '/get-started');
          }
        }}
      />
    );
  }

  if (paymentData) {
    return (
      <PaymentProcessModal
        paymentLink={paymentData?.paymentLink}
        transactionId={paymentData?.reference}
        interacId={paymentData?.interacId}
        amount={paymentData?.interacAmount}
        onClickAway={() => {}}
        onBack={() => {}}
        onClose={() => {
          setShowModalDetails(null);
          setPaymentData(null);
          if (paymentData?.redirectUrl) {
            window.location.href = paymentData.redirectUrl;
          } else {
            navigate('/get-started');
          }
        }}
        onSuccess={() => {
          setShowModalDetails({
            title: 'Payment Successful!',
            message:
              'Your rent payment is successful. You will receive an email notification once the transaction has been successfully completed.',
            iconType: 'success',
            goToLink: '/get-started',
            redirectUrl: paymentData?.redirectUrl
          });
          setPaymentData(null);
        }}
        isShowCloseButton
        isInAppPreRentGuaranteePaymentApplication
      />
    );
  }

  return (
    <div className={PublicPaymentStyle?.wrapper}>
      <Loader />
    </div>
  );
};

export default PublicPayment;
